import React, { useState } from 'react';
import Dialog from '../Dialog/Dialog';
import Button from '../Button/Button';
import Input from '../Input/Input';
import LanguageSection from '../LanguageSection/LanguageSection';
import './CreateProjectDialog.css';

interface CreateProjectDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, placeholderFormat: string, languages: string[]) => Promise<void>;
  isLoading: boolean;
}

const CreateProjectDialog: React.FC<CreateProjectDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  isLoading
}) => {
  const [name, setName] = useState('');
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>(['en']);

  const handleSubmit = async () => {
    if (name.trim()) {
      await onSave(name.trim(), 'web', selectedLanguages);
      setName('');
      setSelectedLanguages(['en']);
    }
  };



  const headerActions = (
    <div className="dialog-header-actions">
      <Button 
        variant="secondary" 
        onClick={onClose}
        disabled={isLoading}
        size="small"
      >
        Cancel
      </Button>
      <Button 
        variant="primary" 
        onClick={handleSubmit}
        disabled={isLoading || !name.trim()}
        isLoading={isLoading}
        size="small"
      >
        Create
      </Button>
    </div>
  );

  return (
    <>
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        title="Create Project"
        headerActions={headerActions}
        showCloseButton={false}
      >
        <div className="create-project-dialog">
          <Input
            label="Project Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter project name"
            disabled={isLoading}
            required
          />

          <LanguageSection
            languages={selectedLanguages}
            onLanguagesChange={setSelectedLanguages}
            draggable={true}
            title="Project Languages"
            description="Select the languages for your project. You can add more languages later."
            emptyMessage="No languages selected"
            addButtonText="Add Language"
            isLoading={isLoading}
            canDelete={true}
          />
        </div>
      </Dialog>


    </>
  );
};

export default CreateProjectDialog; 